'use client';

import { usePathname, useSearchParams } from 'next/navigation';

import { ROUTES } from '@/constants';

export const useLoginHref = () => {
  const pathname = usePathname();
  const search = useSearchParams().toString();

  return ROUTES.LOGIN.withSearchParams({
    searchParams: { redirect: search ? `${pathname}?${search}` : pathname },
  });
};
